import { ProphecyError } from '@prophecy/utils/error';

export const NOT_CONNECTED = 'Websocket is not connected';

/**
 * These rejections reach Sentry through `onunhandledrejection`, where there is no scope to tag them,
 * so the source goes in the message: without it every caller collapses into one issue that names
 * neither the socket nor the method. The message is also what Sentry groups on, since these carry no
 * stack - `ProphecyError` clears its own, and putting a JS one back would surface it in a toast.
 *
 * Lives in its own module because the three websocket modules each spawn a ComlinkWorker at import
 * time; sharing this through any of them would start a second worker in the others.
 */
export function notConnectedError(source: string) {
  return new ProphecyError(`${NOT_CONNECTED}: ${source}`);
}
